export default {
  maximumDryDensity: {
    ARIZ_225d_245c: { rev2019: '110454' },
  },
  nuclearFieldDensity: {
    ARIZ_235: {
      rev1992: '110456',
    },
  },
  oversizeDetermination: { ARIZ_225d_245c: '110455' },
  oversizeCorrection: { ARIZ_227e: '110457' },
};
